import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import Column from "../../../common/components/Column"
import LengthLimitedTextField from "../../../common/components/LengthLimitedTextField"
import DialogHeader from "../components/DialogHeader"

/**
 * Names a new view. With `payload` (filters and sort) it saves what the list
 * shows now; without, it adds an empty view to build on.
 */
export default function AddSavedFilterDialog({
  open,
  onClose,
  page,
  payload,
  title = "Add a view",
}) {
  const [name, setName] = useState("")
  const [isCreating, setIsCreating] = useState(false)

  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleAddButtonClicked() {
    setIsCreating(true)
    axios
      .post("/crm/api/saved-filter/", { name, page, ...(payload || {}) })
      .then(({ data }) => {
        onClose(data)
        setName("")
      })
      .finally(() => setIsCreating(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs">
      <DialogHeader title={title} onClose={handleSoftClose} />
      <DialogContent>
        <Column sx={{ gap: 2 }}>
          <Typography variant="body1">
            {payload
              ? "Save the current filters and sorting as a view."
              : "Add a view, then set its filters and sorting."}
            <br />
            Changes to a view are kept until you save or reset them.
          </Typography>
          <LengthLimitedTextField
            value={name}
            setValue={setName}
            maxLength={128}
            label="Name"
            size="large"
          />
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isCreating}
          disabled={!name}
          onClick={handleAddButtonClicked}
        >
          {payload ? "Save" : "Add"}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
